import React, { Component } from "react";
import { Segment, Message } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import api from "../../api";
import settings from "../../settings";
import Activities from "./Activities";
import { getErrorMessage } from "../messages/errorMessages";

class OlderHistoryResultsAndReports extends Component {
  constructor(props) {
    super(props);
    this.state = { activityNode: null };
  }

  componentDidMount() {
    this.isCompMounted = true;
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  isCompMounted = false;

  loadData = (props) => {
    const params = {
      view: "activities",
      pickedUser: props.pickedUser,
      days: 31,
      month: new Date().getMonth() + 1,
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
    };

    api.lp.getActivitiesView(params).then((res) => {
      parseString(res.data, { async: false }, (err, result) => {
        if(result == null) {
            const errorMessage = "Unable to fetch the details. Please try again";
            const activityNode = (<Message negative>
                        <Message.Header>Something went wrong</Message.Header>
                        <p>{errorMessage}</p>
                      </Message>)
            if (this.isCompMounted) this.setState({ activityNode });
            return;
        }
        const root = Object.keys(result)[0];
        if (root === "errors") {
          if (_.get(result, `${root}.error[0].$.errType`) === "unauthorized") {
            localStorage.errorMessage = _.get(
              result,
              `${root}.error[0].errMsg[0]`,
              ""
            );
            const errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            this.props.expireSession(errorMessage);
          }
        } else {
          const activityNode = (
            <Activities
              key={`activities_older_history`}
              {...this.props}
              data={result.activities}
              noLinks
              days={31}
            />
          );
          if (this.isCompMounted) this.setState({ activityNode });
        }
      });
    });
  };

  render() {
    const { activityNode } = this.state;
    if (activityNode === null) {
      return (
        <Segment
          loading
          className="activity-loading table-no-border box-shadow-none"
        >
          {""}
        </Segment>
      );
    }
    return this.state.activityNode;
  }
}

export default OlderHistoryResultsAndReports;



// WEBPACK FOOTER //
// ./src/components/myaccount/OlderHistoryResultsAndReports.js